<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/areaprojects">
        AreaProjects
      </Link>
      <span class="text-black-400 font-medium"> / </span>
      {{ form.code }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            v-model="form.location"
            :error="form.errors.location"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Location" />
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!areaproject.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete AreaProject
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update AreaProject
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        areaproject: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                code: this.areaproject.code,
                location: this.areaproject.location,
                desc: this.areaproject.desc,
            }),
        }
    },
    methods: {
        update () {
            this.form.put(`/areaprojects/${this.areaproject.id}`)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this areaproject?')) {
                this.$inertia.delete(`/areaprojects/${this.areaproject.id}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this areaproject?')) {
                this.$inertia.put(`/areaprojects/${this.areaproject.id}/restore`)
            }
        },
    },
}
</script>
